// extracted by mini-css-extract-plugin
export default {"background":"ChooseActionPage_background__3I4N2"};